import React from 'react'
// import SampleMessages from './steps/SampleMessages.tsx'
// import Policies from './steps/Policies.tsx'
import Usage from './steps/Usage'
import SampleMessages from './steps/SampleMessages'
import Contact from './steps/Contact'
import PropTypes from 'prop-types'
import { EnrollmentType } from '../../interface/EnrollmentType'
import PreviewContainer from '../PreviewContainer'
import { makeStyles } from '@material-ui/core'

const jss = (theme) => {
    return {
        mb40: {
            marginBottom: 40
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    item: Record<string, unknown>
    onGoBack(): unknown
    onClickEdit(): unknown
    onClickSubmitPaymentFailed?(): unknown
}

/**
 * @param {object} props
 */
const Preview = ({
    item,
    onGoBack,
    onClickEdit,
    onClickSubmitPaymentFailed
}: PropsInterface) => {
    const styles = useStyles()
    // useEffect(() => {
    //     if (props.saveId) props.update({ completed: true, gotoNext: true, saveData: {} })
    // }, [props.saveId])
    return <PreviewContainer
        item={item}
        titleRight={`Campaign ID: ${item.csp_campaign_id}`}
        enrollmentType={EnrollmentType.Campaign}
        onGoBack={onGoBack}
    >
        <div className={styles.mb40} data-testid='campaign-preview'>
            <Usage
                editing={item}
                passData={{}}
                mode='preview'
                onClickEdit={onClickEdit}
                onClickSubmitPaymentFailed={onClickSubmitPaymentFailed}
            />
        </div>
        <div className={styles.mb40}>
            <SampleMessages
                editing={item}
                passData={{}}
                mode='preview'
            />
        </div>
        <div className={styles.mb40}>
            <Contact
                editing={item}
                passData={{}}
                mode='preview'
            />
        </div>
    </PreviewContainer>
}

Preview.propTypes = {
    passData: PropTypes.object,
    update: PropTypes.func,
    saveId: PropTypes.number,
    editing: PropTypes.object,
    preview: PropTypes.bool
}

export default Preview
